var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM11.0003 7.99835C11.5528 7.99835 12.0007 7.55064 12.0007 6.99835C12.0007 6.44607 11.5528 5.99835 11.0003 5.99835C10.4479 5.99835 10 6.44607 10 6.99835C10 7.55064 10.4479 7.99835 11.0003 7.99835ZM12.0036 13.9984C12.5555 13.9984 13.003 14.4461 13.003 14.998C13.003 15.5503 12.5552 15.9984 12.003 15.9984H10.003C9.45068 15.9984 9.00296 15.5506 9.00296 14.9984C9.00296 14.4461 9.45068 13.9984 10.003 13.9984V10.9984C9.45068 10.9984 9.00296 10.5506 9.00296 9.99835C9.00296 9.44607 9.45068 8.99835 10.003 8.99835H11.0036C11.5559 8.99835 12.0036 9.44607 12.0036 9.99835V13.9984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.472323b17e187ad660c20a318a95fbd9.svg";
export { ForwardRef as ReactComponent };